import { requestAsync, httpMethods, UPDATE_DEFAULT } from 'dash-front/requery/actions';
import _ from 'lodash';
import cfg from 'cfg';
import auth from 'dash-front/auth';
import { toIdArray } from 'dash-front/helpers';

const INTERPOLATION_REGEX = /\${[^}]*\}/g;
export const generateTitle = template => template.replace(INTERPOLATION_REGEX, '...');

export const fetchMessages = trigger =>
    requestAsync({
        url: `${cfg.message_service.host}/messages?access_token=${auth.getAccessToken()}${trigger
            ? `&trigger=${trigger}`
            : ''}`,
        update: {
            messageTemplates: UPDATE_DEFAULT.MERGE
        },
        transform: body => ({
            messageTemplates: body.reduce((acc, el) => {
                acc[el._id] = el;
                return acc;
            }, {})
        }),
        list: body => ({
            [trigger ? `messageTemplates/${trigger}` : 'messageTemplates']: () => toIdArray(body)
        }),
        queryKey: trigger ? `GET:messageTemplates/${trigger}` : 'GET:messageTemplates'
    });

export const createMessage = message => {
    const secondaryKey = `messageTemplates/${message.trigger}`;
    return requestAsync({
        url: `${cfg.message_service.host}/messages?access_token=${auth.getAccessToken()}`,
        body: message,
        queryKey: 'POST:messageTemplates',
        list: body => ({
            messageTemplates: prevList => [body._id].concat(prevList),
            [secondaryKey]: prevList => [body._id].concat(prevList)
        }),
        transform: body => ({
            messageTemplates: { [body._id]: body }
        }),
        update: {
            messageTemplates: UPDATE_DEFAULT.MERGE
        },
        options: {
            method: httpMethods.POST
        }
    });
};

export const deleteMessage = messageId => (dispatch, getState) => {
    const { requery } = getState();
    const triggerType = _.get(requery, ['entities', 'messageTemplates', messageId, 'trigger']);
    const secondKey = `messageTemplates/${triggerType}`;
    const action = requestAsync({
        url: `${cfg.message_service.host}/messages/${messageId}?access_token=${auth.getAccessToken()}`,
        queryKey: `DELETE:messageTemplates/${messageId}`,
        list: body => ({
            messageTemplates: prevList => prevList.filter(e => e !== messageId),
            [secondKey]: prevList => prevList.filter(e => e !== messageId)
        }),
        transform: body => ({
            messageTemplates: {}
        }),
        update: {
            messageTemplates: UPDATE_DEFAULT.MERGE
        },
        options: {
            method: httpMethods.DELETE
        }
    });
    return dispatch(action);
};

export const updateMessage = message => (dispatch, getState) => {
    const { _id } = message;
    const action = requestAsync({
        url: `${cfg.message_service.host}/messages/${_id}?access_token=${auth.getAccessToken()}`,
        body: message,
        queryKey: `PUT:messageTemplates/${_id}`,
        list: body => ({}),
        transform: body => ({
            messageTemplates: { [body._id]: body }
        }),
        update: {
            messageTemplates: UPDATE_DEFAULT.MERGE
        },
        options: {
            method: httpMethods.PUT
        }
    });
    return dispatch(action);
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/messages/actions.js
 **/